import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';
import mixpanel from "mixpanel-browser/src/loader-module";
import { loanStatus } from 'projects/apna-lib/src/lib/components/enums/loanStatus-enum';
import { TooltipDirective } from 'projects/apna-lib/src/lib/directives/tooltip.directive';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { HeaderInterface } from 'projects/apna-lib/src/lib/interfaces/common-interface';
declare let gtag: Function;

export const Loan = {
  Secured: "Secured Loan(with Property)",
  Unsecured: "Unsecured Loan(without Property)",
  International: 'International Loan(Non Collateral-Cosigner)'
}
@Component({
  selector: 'fa-loan-vendor-list',
  templateUrl: './loan-vendor-list.component.html',
  styleUrls: ['./loan-vendor-list.component.scss']
})

export class LoanVendorListComponent implements OnInit {
  @ViewChild('openCongratulationPopup') openCongratulationPopup
  vendors: any[] = [];
  selectedVendors: any[] = [];
  isSelected: boolean[] = [];
  checkedVendorList: any[] = [];

  isPartnerLink: boolean = false;
  partnerLogo: string;
  userData: {};
  isAlertVisible: boolean = false;
  loading: boolean = true;
  isCardChecked: boolean = true;

  configVendorListHeader: HeaderInterface = {
    title: "Your Loan Offers",
    back: {
      link: '/loan-details',
      step: 'firstStep'
    },
    logout: undefined
  }

  @ViewChild('content') content;
  @ViewChild("openErrorPopup") openErrorPopup;
  @ViewChild('openSortByModal') openSortByModal: TooltipDirective;
  @ViewChild('openTermsAndConditionModal') openTermsAndConditionModal: TooltipDirective;
  @ViewChild(TooltipDirective) toolTipDirective: TooltipDirective;
  vendorData: any[] = [];
  orientation: String;
  sortParam: String;
  constructor(
    public loanService: LoanGtmService,
    private route: Router,
    private apiHelper: ApiHelperService,
    private spinner: NgxSpinnerService,
    private userIdentity: UserIdentityService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    public breakpointObserver: BreakpointObserver
  ) { }

  identify(user_id, userData = {}) {
    mixpanel.identify(user_id, userData)
  }

  trackEvent(event, data = {}) {
    mixpanel.track(event, data)
  }

  ngOnInit(): void {

    this.breakpointObserver
      .observe(['(max-width: 576px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.orientation = 'vertical';
        } else {
          this.orientation = 'horizontal';
        }
      });
    if (typeof window !== 'undefined' && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('uat')) {
      mixpanel.init('36f7bc976b3c6dc024e372be5c7d26f8'); //change the token as per environment
    }
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    if (puid) {
      this.configVendorListHeader["logout"] = `/${puid}`;
      localStorage.setItem('puid', puid);
      this.isPartnerLink = true;
      if (!this.loanService?.partnerDetails) {
        this.getPartnerDetails(puid);
      }
      else {
        this.partnerLogo = this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined;
      }
    }
    else {
      this.configVendorListHeader["logout"] = `/`;
    }
    this.checkUserLoggedIn();
  }

  getPartnerDetails(partnerUid) {
    this.apiHelper.getDataById("users/partner", partnerUid).subscribe((response: any) => {
      let partnerDetails = { ...response };
      if (partnerDetails) {
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;
      }
      else {
        this.isPartnerLink = false;
      }
    })
  }

  checkUserLoggedIn() {
    if (!this.loanService.studentDetails?.mobile) {
      if (this.isPartnerLink) {
        this.route.navigate([this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate([" "]);
      return;
    }
    else if (!this.userIdentity.isLoggedIn.getValue()) {
      if (this.isPartnerLink) {
        this.route.navigate(['personal-details/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['/personal-details']);
      return;
    }
    else if (!this.loanService?.loanDetails) {
      if (this.isPartnerLink) {
        this.route.navigate(['loan-details/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['/loan-details']);
      return;
    }
    this.getLoanApplication();
  }

  getLoanApplication() {
    if (this.loanService?.studentDetails?.id) {
      this.loanService.getLoanApplication(this.loanService?.studentDetails?.id).then((data: any) => {
        if (data) {
          let nullRemoved = this.removeEmpty(data[0]);
          this.loanService.saveLoanApplication(nullRemoved);
          this.getSuggestedVendors();
        }
      })
    }
  }

  removeEmpty(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
      else if (typeof obj[propName] == 'object') {
        this.removeEmpty(obj[propName]);
      }
    }
    return obj
  }

  removeEmptyFromArray(obj: any) {
    const data = obj?.filter((single: any) => {
      return single !== null || single !== undefined
    })
    return data
  }

  async getSuggestedVendors() {
    this.spinner.show();
    await this.apiHelper.getData("get-suggested-vendor-list", { where: { studentId: this.loanService?.studentDetails?.id, loanApplicationId: this.loanService?.loanDetails?.id } }).then((data: any) => {
      if (this.orientation === 'vertical' || this.orientation === 'horizontal') {
        data.forEach((single: any) => {
          this.isSelected.push(false)
        })
      } 
      if (data.length === 0) {
        if (this.loanService.studentDetails?.puid) {
          this.route.navigate(["university-vendors/" + this.loanService.studentDetails?.puid]);
        }
        else {
          this.route.navigate(["university-vendors"]);
        }
        return;
      }
      this.vendors = [...data];
      this.dataPreprocessor(this.vendors);
      // if (this.orientation === "horizontal") {
      //   this.selectedVendors = [...data];
      // }
      this.checkedVendorList = data.map((single: any) => {
        return single?.id?.toString();
      });
      this.spinner.hide();
      this.loading = false;
    })

    if (this?.vendors?.length === 0) {
      this.apiHelper.updateMultipleRecord("leads", { studentId: this.loanService?.studentDetails?.id, service: "Loan" }, { status: loanStatus.draft }).subscribe((data) => {
        return data
      })
      this.apiHelper.updateData("loan-applications", this.loanService?.loanDetails?.id, { status: loanStatus.draft }).subscribe((data) => {
        return data
      })
    }
  }

  addRemoveVendor(event: any, index?: any) {
      this.isSelected[index] = !this.isSelected[index]
      this.updateSelectedVendors(event, this.isSelected[index]);
  }

  applyShadow(valueId: any, checked: boolean) {
    if (checked && this.checkedVendorList?.includes(valueId?.id)) {
      return;
    }
    else if (checked && !this.checkedVendorList?.includes(valueId?.id)) {
      this.checkedVendorList.push(valueId?.id);
    }
    else if (!checked && this.checkedVendorList?.includes(valueId?.id)) {
      const index = this.checkedVendorList.indexOf(valueId?.id);
      delete this.checkedVendorList[index];
    }
  }

  async updateSelectedVendors(vendor: any, checked: boolean) {
    if (checked) {
      if (this.selectedVendors?.length == 0) {
        this.selectedVendors.push(vendor);
      }
      else {
        let exists = false;
        for await (const single of this.selectedVendors) {
          if (single?.id === vendor?.id) {
            exists = true;
          }
        }
        if (!exists) {
          this.selectedVendors.push(vendor);
        }
      }
    }
    else {
      this.selectedVendors = this.selectedVendors.filter((single: any) => {
        return single?.id !== vendor?.id;
      })
    }
  }

  dataPreprocessor(vendors: any[]) {
    vendors.forEach((vendor: any) => {
      if (vendor) {
        vendor["vendorNameCaseChanged"] = vendor?.company?.name.toLowerCase().replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}\[\]\\\/\s]/g, '');
      }
    })
  }

  async sendApplication() {
    if (typeof window !== "undefined" && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('qa') && !window.location.host.includes('uat')) {
      this.userData = {
        source: "Loan Widget",
      }
      if (this.loanService.partnerDetails) {
        this.userData["PartnerName"] = this.loanService.partnerDetails?.company.name;
      }
      this.trackEvent("Send Application on Loan Widget Clicked", this.userData)
    }
    let loanApplicationVendorData: any[] = [];

    if (this.selectedVendors?.length > 0) {
      for await (const single of this.selectedVendors) {
        let obj = {
          vendorId: single?.id,
          loanApplicationId: this.loanService?.loanDetails?.id,
          studentId: this.loanService?.studentDetails?.id,
        }
        loanApplicationVendorData.push(obj);
      }

      this.apiHelper.postData("loan-application-vendor/multiple", loanApplicationVendorData).subscribe((data: any) => {
        if (this.isPartnerLink) {
            this.route.navigate(['result-page/' + this.loanService?.partnerDetails?.uid]);
          }
          else {
            this.route.navigate(['result-page'])
          }
      })
      this.apiHelper.updateData("loan-applications", this.loanService.loanDetails?.id, { status: "applied" })

      gtag('event', 'send_application_submit', {
        'event_category': 'button',
        'event_label': 'Send application submit button',
        'value': "Send application information"  
      });
  
      gtag('config','G-LW5LDX8EDG',{
        'user_id': this.loanService?.studentDetails?.mobile
      })
  

    }
    else {
      this.openErrorDialog()
      //this.apiHelper.openSnackBar("Please select atleast one vendor");
      return;
    }
  }

  openErrorDialog() {
    this.modalService.open(this.openErrorPopup, {
      centered: true,
      size: 'l'
    })
  }

  goBack() {
    this.modalService.dismissAll();
  }

  back() {
    if (this.loanService.loanDetails?.loanType == 'Secured Loan(with Property)') {
      if (this.isPartnerLink) {
        this.route.navigate(['collateral-type/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['./collateral-type']);
      return;
    }
    else if (this.loanService.loanDetails?.loanType == 'Unsecured Loan(without Property)') {
      if (this.isPartnerLink) {
        this.route.navigate(['non-collateral-type/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['./non-collateral-type']);
      return;
    }
    else {
      if (this.isPartnerLink) {
        this.route.navigate(['loan-details/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['./loan-details']);
      return;
    }
  }

  clearDetails() {
    this.loanService.setDefaultDetails();
  }

  raiseARequest() {
    this.modalService.open(this.content, { centered: true });
    let loanRequest: any = {
      id: this.loanService?.studentDetails?.id,
      name: `${this.loanService.studentDetails?.firstName + " " + this.loanService.studentDetails?.lastName}`,
      email: this.loanService.studentDetails?.email,
      mobile: this.loanService.studentDetails?.mobile,
      loanType: this.loanService.loanDetails?.loanType
    };

    if (this.isPartnerLink) {
      loanRequest.partnerName = this.loanService?.partnerDetails?.name;
      loanRequest.showAgentCode = this.loanService?.partnerDetails?.company?.showAgentCode ? true : false
    }
    this.apiHelper.postData("send-loan-application-request", loanRequest).subscribe(() => {
      this.apiHelper.openSnackBar("Sent request Successfully!");
    })
  }

  startOver() {
    if (this.isPartnerLink) {
      this.route.navigate(['basic-information/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['./basic-information']);
    return;
  }

  showAlert() {
    this.isAlertVisible = !this.isAlertVisible;
  }

  logout() {
    if (this.isPartnerLink) {
      this.route.navigate(['/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/'])
  }

  sortByHandler(param: String) {
    this.sortParam = param
    if (param == 'rateOfInterest') {
      this.vendorData = this.vendors.map(single => {
        if (this.loanService.loanDetails?.loanType === Loan.Secured) {
          return { rateOfIntrest: single?.company?.vendorDetails?.collateral?.rateOfInterest, vendorId: single?.id }
        }
        else if (this.loanService.loanDetails?.loanType === Loan.Unsecured || this.loanService.loanDetails?.loanType === Loan.International) {
          return { rateOfIntrest: single?.company?.vendorDetails?.nonCollateral?.rateOfInterest, vendorId: single?.id }
        }
      })

      const ascendingData = this.vendorData.sort((firstItem, secondItem) => {
        const rate1 = parseFloat(firstItem.rateOfIntrest);
        const rate2 = parseFloat(secondItem.rateOfIntrest);
        return rate1 - rate2;
      });

      const sortedVendors = this.vendorData.map(item => {
        const vendorId = item.vendorId;
        return this.vendors.find(vendor => vendor.id === vendorId);
      });

      this.vendors = sortedVendors

    }

    else if (param == 'loanTenure') {
      this.vendorData = this.vendors.map(single => {
        return { tenure: single?.company?.vendorDetails?.tenure, vendorId: single?.id }
      })

      const ascendingData = this.vendorData.sort((firstItem, secondItem) => {

        const rate1 = parseInt(firstItem.tenure?.split(" ")[1]);
        const rate2 = parseInt(secondItem.tenure?.split(" ")[1]);
        return rate1 - rate2;
      });

      const sortedVendors = this.vendorData.map(item => {
        const vendorId = item.vendorId;
        return this.vendors.find(vendor => vendor.id === vendorId);
      });

      this.vendors = sortedVendors
    }

    this.toolTipDirective.close();
    this.modalService.dismissAll();
  }

  prepareViewLoanAmount(amount: string) {
    if (amount) {
      return (Number((amount))).toLocaleString('en-IN', {
        maximumFractionDigits: 2,
        currency: 'INR'
      }).replace("$", "").split(".")[0].toString();
    }
    else {
      return 0
    }
  }

  checkStatus() {
    this.modalService.dismissAll()
    if (this.isPartnerLink) {
      this.route.navigate(['/application-status/' + this.loanService?.partnerDetails?.uid])
      return;
    }
    this.route.navigate(['/application-status'])
  }

  openModalSortBy() {
    const options: NgbModalOptions = {
      windowClass: 'modal-bottom',
      animation: true,
      size: "xl"
    };
    this.modalService.open(this.openSortByModal, options)
  }

  openTermsModal() {
    const options: NgbModalOptions = {
      windowClass: 'modal-bottom',
      animation: true,
      size: "xl"
    };
    this.modalService.open(this.openTermsAndConditionModal, options)
  }

  emitStep(ev: any) {
    if (this.loanService.loanDetails?.loanType === Loan.Secured) {
      sessionStorage.setItem("stepHeading", "secondStep")
      if (this.isPartnerLink) {
        this.route.navigate(["collateral-type/" + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(["collateral-type"]);
    }
    else if (this.loanService.loanDetails?.loanType === Loan.Unsecured) {
      if (this.isPartnerLink) {
        this.route.navigate(["non-collateral-type/" + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(["non-collateral-type"]);
    }
    else {
      if (this.isPartnerLink) {
        this.route.navigate(["loan-details/" + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(["loan-details"]);
    }


  }
}
